

import React, { memo, useState, useEffect } from 'react';
import PlacesAutocomplete from 'react-places-autocomplete';

import Dropdown from '../../Dropdown';















/**
 *  Builds a Google Places API search options object
 *
 * @param {UserLocation} coords
 *
 * @return {Object}
 */
function getSearchOptions({ coords } = {}) {
  if (!coords) {return {};}

  return {
    // Google is a global window var injected through the script by LocationSelectorRoot.
    // This component isn't rendered until that script is globally available.
    // $FlowFixMe
    location: new google.maps.LatLng(coords.latitude, coords.longitude),
    radius: 2000,
    types: ['geocode']
  };
}

function buildAddressLabel(suggestion) {
  const { description } = suggestion;
  const split = description.split(',');
  const street = split[0];
  const addressWithoutStreet = split.slice(1, split.length);

  return { label: `${street}, ${addressWithoutStreet}`, value: suggestion };
}

function buildSuggestionList(suggestions) {
  return suggestions.map(buildAddressLabel);
}

const onSelectAddress = (
getSuggestionItemProps,
setPlaceholderHidden) =>
({ value: suggestion }) => {
  setPlaceholderHidden(true);
  getSuggestionItemProps(suggestion).onClick();
};

const onSearch = (onChange) => (value) => {
  onChange({ target: { value } });
};

function LocationSelector({
  addressString,
  onChangeAddress,
  onSelect,
  userLocation,
  placeholder,
  isManualEntry,
  disabled,
  requestUserLocation,
  id,
  dropdownType,
  renderMenuLocally
}) {
  const [hidePlaceholder, setPlaceholderHidden] = useState(false);

  useEffect(() => {
    setPlaceholderHidden(false);
  }, [isManualEntry, disabled]);

  return (
    <PlacesAutocomplete
      value={addressString}
      onChange={onChangeAddress}
      onSelect={onSelect}
      searchOptions={getSearchOptions(userLocation)}>

      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => {
        const { onChange } = getInputProps() || /* istanbul ignore next */{};

        return (
          <Dropdown
            id={id}
            options={buildSuggestionList(suggestions)}
            isSearchable
            onInputChange={onSearch(onChange)}
            onChange={onSelectAddress(getSuggestionItemProps, setPlaceholderHidden)}
            isLoading={loading}
            disabled={hidePlaceholder || isManualEntry || disabled}
            placeholder={hidePlaceholder || isManualEntry ? '' : placeholder}
            value={null}
            noResultsText="We couldn't find your address"
            onFocus={requestUserLocation}
            type={dropdownType}
            renderMenuLocally={renderMenuLocally} />);


      }}
    </PlacesAutocomplete>);

}

export default memo(LocationSelector);